<div class="container d-flex flex-column custom-height">
    <div class="row flex-grow-1 align-items-center justify-content-center">
        <div class="container">
            <div class="d-flex justify-content-center align-items-center">
                <img [src]="logoSrc" alt="QubeApps Logo" class="logo-img">
            </div>
            <div class="row gy-3 ">
                <div class="col-sm-12 text-center title">
                    Oops!
                </div>
                <div class="col-sm-12 text-center sub-title">
                    USER NOT FOUND
                </div>
            </div>
        </div>
    </div>
</div>
